import { ILandingTutorial, TypeSlugLanding } from 'app_types/admin/landings/landingTypes'
import { ITerm } from 'app_types/admin/term/term.types'
import React, { FC } from 'react'
import { Modal } from 'react-bootstrap'
import TutorialForm from '../TutorialForm/TutorialForm'

import './ModalTutorialForm.scss'

interface IModalTutorialFormProps {
  onClose: (saved?: boolean) => void
  open: boolean
  editData?: ILandingTutorial
  slug: TypeSlugLanding
  publicGroups: ITerm[]
}

const ModalTutorialForm: FC<IModalTutorialFormProps> = ({ onClose, open, editData, slug, publicGroups }) => {
  const handleCloseModal = () => {
    onClose()
  }

  return (
    <Modal
      show={open}
      onHide={handleCloseModal}
    >
      <Modal.Header>
        <Modal.Title>
          {!!editData ? 'Editar tutorial' : 'Crear tutorial'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <TutorialForm
          editData={editData}
          onClose={onClose}
          slug={slug}
          key={editData?.unique}
          publicGroups={publicGroups}
        />
      </Modal.Body>
    </Modal>
  )
}

export default ModalTutorialForm
